import React from 'react'
import MasterLayout from '../../masterLayout/MasterLayout'
import Breadcrumb from '../../components/Breadcrumb'
import BlockScriptsLayer from '../../components/Settings/BlockScriptsLayer'

const BlockScriptsPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title='Block / Allow Scripts' />
      <BlockScriptsLayer />
    </MasterLayout>
  )
}

export default BlockScriptsPage
